module.exports = __webpack_public_path__ + "static/media/v30.4dba0f4d.mp4";